import _ from "lodash";

const Legend = ({ categories }) => {
  const buildLegend = () => {
    return _.map(categories, (category, key) => {
      return (
        <li key={`cat-${key}`}>
          <div className={key}></div>
          {category.name}
        </li>
      );
    });
  };

  return (
    <>
      <div className="legend">
        <h2>Legend</h2>
        <ul>{buildLegend()}</ul>
      </div>
    </>
  );
};

export default Legend;
